module.exports = __webpack_public_path__ + "media/images/flf-flower_corrected-e6b26a937991394cbb71d011fe533ce7.jpg";